import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Switch } from "@/components/ui/switch";
import { isRivieraPath } from "@/components/CountrySwitcher";

const KEY = "tl_cookie_consent";
const EVT = "tl-open-cookie-settings";
export const openCookieSettings = () => window.dispatchEvent(new Event(EVT));
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; } };

export default function CookieConsent() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [consent, setConsent] = useState(read);
  const [custom, setCustom] = useState(false);
  const [analytics, setAnalytics] = useState(!!read()?.analytics);
  useEffect(() => {
    const open = () => { setCustom(true); setConsent(null); window.dispatchEvent(new CustomEvent("tl-cookie-banner", { detail: true })); };
    window.addEventListener(EVT, open);
    return () => window.removeEventListener(EVT, open);
  }, []);
  if (consent || pathname.startsWith("/admin") || pathname.startsWith("/portal")) return null;

  const save = (a) => {
    const prev = read();
    const c = { necessary: true, analytics: a, at: new Date().toISOString(), v: 1 };
    localStorage.setItem(KEY, JSON.stringify(c));
    setConsent(c);
    window.dispatchEvent(new CustomEvent("tl-cookie-banner", { detail: false }));
    if (a && window.__tlLoadAnalytics) window.__tlLoadAnalytics();
    if (!a && prev?.analytics) { try { window.posthog?.opt_out_capturing?.(); } catch { /* ignore */ } window.location.reload(); }
  };
  const policy = isRivieraPath(pathname) ? "/fr/cookies" : "/privacy";
  const btn = "inline-flex items-center justify-center h-10 px-4 rounded-full text-sm font-semibold transition-colors";
  return (
    <div className="tl-public fixed inset-x-3 bottom-3 sm:inset-x-auto sm:left-4 sm:max-w-md z-[60] bg-white rounded-2xl shadow-2xl ring-1 ring-slate-200 p-5" role="dialog" aria-label={t("cookies.title")} data-testid="cookie-banner">
      <h2 className="text-lg text-[#0F172A]">{t("cookies.title")}</h2>
      <p className="mt-1.5 text-xs text-slate-600 leading-relaxed">{t("cookies.body")} <Link to={policy} className="underline" data-testid="cookie-policy-link">{t("cookies.policy")}</Link></p>
      {custom && (
        <div className="mt-3 space-y-2 text-sm" data-testid="cookie-customize">
          <label className="flex items-center justify-between gap-3"><span>{t("cookies.necessary")}</span><Switch checked disabled /></label>
          <label className="flex items-center justify-between gap-3"><span>{t("cookies.analytics")}</span><Switch checked={analytics} onCheckedChange={setAnalytics} data-testid="cookie-analytics-toggle" /></label>
        </div>
      )}
      <div className="mt-4 grid grid-cols-2 gap-2">
        <button type="button" onClick={() => save(false)} className={`${btn} ring-1 ring-slate-300 text-[#1B3A6B] hover:bg-slate-50`} data-testid="cookie-reject">{t("cookies.reject")}</button>
        <button type="button" onClick={() => save(true)} className={`${btn} bg-[#1B3A6B] text-white hover:bg-[#102547]`} data-testid="cookie-accept">{t("cookies.accept")}</button>
        {custom
          ? <button type="button" onClick={() => save(analytics)} className={`${btn} col-span-2 text-[#5BA83F] hover:underline`} data-testid="cookie-save">{t("cookies.save")}</button>
          : <button type="button" onClick={() => setCustom(true)} className={`${btn} col-span-2 text-slate-600 hover:underline`} data-testid="cookie-customize-btn">{t("cookies.customize")}</button>}
      </div>
    </div>
  );
}
